import { useMemo, useState, useEffect } from 'react';
import type { Control } from 'react-hook-form';
import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '@/_components/checkbox';
import type { Permissions } from '@/Interfaces/Data';
import styles from './styles.module.scss';

interface Props {
  options: Array<OptionsProps>;
  title: string;
  // TODO fix ts
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  objName: 'delivery' | 'deliveryman' | 'place' | 'city';
  className?: string;
}

type OptionsProps = {
  key: string;
  text: string;
  value: string;
  checked?: boolean;
};

function BoxCheckbox({ options, title, objName, control, className }: Props) {
  const [refecthQuantity, setRefecthQuantity] = useState(false);
  const [valuesPermissions, setValuesPermissions] =
    useState<Permissions | null>(null);

  const { getValues, setValue } = useFormContext();

  function checkAll(check: boolean) {
    options.forEach(item => {
      if (check) {
        item.checked = false;
        setValue(`permissions.${objName}.${item.key}`, false);
      } else {
        item.checked = true;
        setValue(`permissions.${objName}.${item.key}`, true);
      }
    });
  }

  const quantity = useMemo(() => {
    return options.filter(e => e.checked === true).length;
  }, [refecthQuantity]);

  const hasAllOption = options.some(option => option.key === 'all');
  const isAllChecked = !!options.find(option => option.key === 'all')?.checked;
  const countLabel =
    hasAllOption && quantity === options.length ? 'Todos' : quantity;

  useEffect(() => {
    options.forEach(
      item => (item.checked = getValues()?.permissions?.[objName][item.key]),
    );
    setValuesPermissions(getValues()?.permissions);
    setRefecthQuantity(!refecthQuantity);
  }, [options]);

  return (
    <div className={`${styles.container} ${className || ''}`}>
      <div>
        <span>{title}</span>
        <span>({countLabel})</span>
      </div>

      {options.map(item => {
        return (
          <div key={item.value}>
            <Controller
              name={`permissions.${objName}.${item.key}`}
              control={control}
              render={({ field: { onChange } }) => (
                <>
                  {valuesPermissions && (
                    <Checkbox
                      id={item.value}
                      label={item.text}
                      checked={!!item.checked}
                      disabled={item.key !== 'all' && isAllChecked}
                      onCheckedChange={(e: boolean) => {
                        if (item.key === 'all') {
                          checkAll(!!item.checked);
                        } else {
                          item.checked = e;
                          onChange(e);
                        }
                        setRefecthQuantity(!refecthQuantity);
                      }}
                    />
                  )}
                </>
              )}
            />
          </div>
        );
      })}
    </div>
  );
}

export default BoxCheckbox;
